import type { TMessages } from '@/types/TMessages'

export const messages = {
  tooltip: {
    mandarin: `MANDARIN - финтех платформа, входит в ТОП-10 платежных сервисов РФ.\nПоставщиками платформы являются более 15 банков, в том числе 3 из 10 крупнейших банков страны.`,
  },
} satisfies TMessages
